export default {"src":"/uk/_next/static/media/moneyStacksIcon.29fffa46.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};